export default "__VITE_ASSET__CYwm8qZl__"